package com.karawek.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

enum class CoreTagTone {
    None,
    Info,
    Warning,
    Error,
}

@Composable
fun CoreTag(
    text: String,
    modifier: Modifier = Modifier,
    tone: CoreTagTone = CoreTagTone.None,
) {
    val (bg, fg) = when (tone) {
        CoreTagTone.None -> CoreTheme.colors.primary.copy(alpha = CoreAlphas.SelectedSurface) to CoreTheme.colors.onBackgroundStrong
        CoreTagTone.Info -> CoreTheme.colors.infoSurface to CoreTheme.colors.infoAccent
        CoreTagTone.Warning -> CoreTheme.colors.warningSurface to CoreTheme.colors.warningAccent
        CoreTagTone.Error -> CoreTheme.colors.errorSurface to CoreTheme.colors.errorAccent
    }

    Box(
        modifier = modifier
            .background(
                color = bg,
                shape = RoundedCornerShape(999.dp),
            )
            .padding(horizontal = CoreSpacing.sm, vertical = CoreSpacing.xs),
    ) {
        Text(
            text = text,
            style = CoreTypography.caption,
            color = fg,
        )
    }
}
